import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107108Status: 'idle',
    startProcess107108Error: undefined as any,
    loadUserParamsProcess107108Status: 'idle',
    loadUserParamsProcess107108Error: undefined as any,

    process107108List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107108 = createAsyncThunk('process107108Slice/startProcess107108', async ({ process107108 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107108/`,
        prepareData(process107108),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107108Status } = getState().process107108Slice
        return startProcess107108Status !== 'pending'
    }
})

export const loadUserParamsProcess107108 = createAsyncThunk('process107108Slice/loadUserParamsProcess107108', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107108/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107108Status } = getState().process107108Slice
        return loadUserParamsProcess107108Status !== 'pending'
    }
})

const Process107108Slice = createSlice({
    name: 'process107108Slice',
    initialState,
    reducers: {
        resetstartProcess107108: (state) => {
            state.job = undefined
            state.startProcess107108Error = undefined
        },
        resetstartProcess107108Error: (state) => {
            state.startProcess107108Error = undefined
        },
        resetloadUserParamsProcess107108: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107108Error = undefined
        },
        resetloadUserParamsProcess107108Error: (state) => {
            state.loadUserParamsProcess107108Error = undefined
        },
        removeFromProcess107108ListById: (state, action) => {
            state.process107108List = state.process107108List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107108ListByIds: (state, action) => {
            state.process107108List = state.process107108List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107108List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107108Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107108List = []
            state.startProcess107108Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107108.pending, (state) => {
            state.startProcess107108Status = 'pending'
            state.startProcess107108Error = undefined
        })
        builder.addCase(startProcess107108.fulfilled, (state, action) => {
            state.startProcess107108Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107108.rejected, (state, action) => {
            state.startProcess107108Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107108Error = action.error.message
            } else {
                state.startProcess107108Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107108.pending, (state) => {
            state.loadUserParamsProcess107108Status = 'pending'
            state.loadUserParamsProcess107108Error = undefined
        })
        builder.addCase(loadUserParamsProcess107108.fulfilled, (state, action) => {
            state.loadUserParamsProcess107108Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107108.rejected, (state, action) => {
            state.loadUserParamsProcess107108Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107108Error = action.error.message
            } else {
                state.loadUserParamsProcess107108Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107108,
    resetstartProcess107108Error,
    resetloadUserParamsProcess107108,
    resetloadUserParamsProcess107108Error,
    removeFromProcess107108ListById,
    removeFromProcess107108ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107108Slice.actions
export default Process107108Slice.reducer
